import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 91,
	height: 48,
	viewBox: "0 0 182 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("desc", { children: "Raging Bear Interactive" }), /* @__PURE__ */ _jsx("image", {
		href: "/rbi/rbi-logo.png",
		width: 182,
		height: 96
	})]
});
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
